import React from 'react';

import { SCREEN_SM_MIN } from '../../../constants/spacingConstants';
import type { LeaseActionProps } from '../../../models/Types';
import { REGISTER_TO_VOTE_LINK } from '../../../constants/stringConstants';

export default class OpenTabRegisterToVote extends React.Component<LeaseActionProps> {
  render() {
    const target = document.body.getBoundingClientRect().width < SCREEN_SM_MIN ? '_self' : '_blank';

    try {
      const newTab = window.open(REGISTER_TO_VOTE_LINK, target);
      if (newTab) {
        newTab.focus();
      }
    } catch (err) {
      // ignored
    }

    this.props.terminateActiveAction();

    return null;
  }
}
